import type {
  DocumentItem,
  DocumentFileList,
  PrepareUploadFiles,
  OCRFileDataItem,
} from '@/api/product/model/documentModel'
import type { Mutation } from 'vuex'
import type { State } from './state'

import actionTypes from './actionTypes'
import { SortInfo } from '@/views/product/DocumentDetail/types/sort'

const mutations: { [actionTypes: string]: Mutation<State> } = {
  [actionTypes.SET_MODAL_FILE_ADDITION_ACTIVE_STATUS]: (
    state: State,
    status: boolean
  ): void => {
    state.modalFileAdditionActived = status
  },

  [actionTypes.SET_MODAL_PRODUCT_RELATION_ACTIVE_STATUS]: (
    state: State,
    status: boolean
  ): void => {
    state.modalProductRelationActived = status
  },

  [actionTypes.SET_DOCUMENT_ITEM]: (state: State, item: DocumentItem): void => {
    state.originalDocumentItem = { ...item }
  },

  [actionTypes.SET_COMPARE_DOCUMENT_ITEM]: (state: State, item: DocumentItem): void => {
    state.compareDocumentItem = { ...item }
  },

  [actionTypes.SET_REMARK]: (state: State, remark: string): void => {
    state.originalDocumentItem.remark = remark
  },

  [actionTypes.SET_REMARK_ERROR]: (state: State, error: string): void => {
    state.remarkError = error
  },

  [actionTypes.SET_FILE_LIST]: (state: State, list: DocumentFileList): void => {
    state.originalDocumentItem.file_list = [...list]
  },

  [actionTypes.SET_SELECTED_FILE]: (state: State, file: File | undefined): void => {
    state.selectedFile = file
  },

  [actionTypes.SET_SELECTED_FILE_ERROR]: (state: State, error: string): void => {
    state.selectedFileError = error
  },

  [actionTypes.SET_SELECT_FILE_UNDER_ERROR]: (state: State, error: string): void => {
    state.selectFileUnderError = error
  },

  [actionTypes.SET_NEW_FILE_REVISION_DATE]: (state: State, date: string): void => {
    state.newFileRevisionDate = date
  },

  [actionTypes.SET_NEW_FILE_REVISION_DATE_ERROR]: (state: State, error: string): void => {
    state.newFileRevisionDateError = error
  },

  [actionTypes.SET_PREPARE_UPLOAD_FILES]: (
    state: State,
    fileList: PrepareUploadFiles
  ): void => {
    state.prepareUploadFiles = [...fileList]
  },

  [actionTypes.SET_FORM_UPDATE_STATUS](state, status: boolean): void {
    state.formUpdated = status
  },

  //ドキュメント詳細画面　ファイル一覧ソート情報
  [actionTypes.SET_SORT_INFO](state, info: SortInfo): void {
    state.sortInfo = info
  },

  [actionTypes.SET_UPLOAD_FILE_TYPE](state, info: string): void {
    state.uploadFileType = info
  },
  [actionTypes.SET_OCR_DATA_ITEM]: (state: State, item: OCRFileDataItem): void => {
    state.originalOcrDataItem = { ...item }
  },

  [actionTypes.SET_COMPARE_OCR_DATA_ITEM]: (state: State, item: OCRFileDataItem): void => {
    state.compareOcrDataItem = { ...item }
  },

  [actionTypes.SET_OCR_UPDATE_MESSAGE]: (state: State, message: string): void => {
    state.ocrUpdateMessage = message
  },
}

export default mutations
